import { useQuery } from '@tanstack/react-query';
import { queryKeys } from 'services/hooks/queryKeys';
import { postPersistTranscript } from 'services/api/postPersistTranscript';

export const usePostPersistTranscript = (roomName?: string, isEnabled = true) => {
    const { data, isLoading, ...rest } = useQuery({
        queryKey: queryKeys.persistTranscript(roomName),
        queryFn: () => postPersistTranscript(roomName),
        enabled: !!roomName && isEnabled,
        retry: 2,
    });

    return {
        isPersistTranscriptSuccess: data?.status === 'success',
        persistTranscript: data,
        isLoading,
        ...rest,
    };
};
